import styled, {css, keyframes} from "styled-components";

interface GradientBorderBoxProps {
    isClickable: boolean;
    borderRadius: string;
    borderWidth: string;
    borderGradient: string;
    rotation?: boolean;
}

const rotationKF = keyframes`
    0% {
        --deg: 15deg;
    }
    100% {
        --deg: 375deg;
    }
`;

export const GradientBorderDefaultBox = styled.div<GradientBorderBoxProps>`  
    box-sizing: border-box;
    background-color: #000;
    background: url(${props => props.theme.assets.images.magic_8_ball.button.magic_8_ball_button_bg_png.toString()}) center center #000;
    background-clip: padding-box; /* !important */
    border: ${props => props.borderWidth} solid transparent; /* !important */
    border-radius: ${props => props.borderRadius};
    cursor: ${props => props.isClickable ? "pointer" : "unset"};

    &:before {  
        @property --deg {
            syntax: "<angle>";
            inherits: false;
            initial-value: 0deg;
        }
        --deg: 15deg;
        content: '';
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        z-index: -1;
        /* margin: -${props => props.borderWidth}; */
        border-radius: inherit; /* !important */
        background: ${props => props.borderGradient};
        ${props => props.rotation ? css`
            animation: ${rotationKF} 10s linear infinite normal none;
        ` : null}
    }
`;